import { gql } from '@apollo/client';
import STUDY_INFO_CLINIC_FRAGMENT from '../fragments/studyInfoClinicFragment';

const STUDY_INFO_CLINIC_QUERY = gql`
  query studyInfoClinic($id: ID!) {
    study(id: $id) {
      ...StudyInfoClinicFragment
    }
  }

  ${STUDY_INFO_CLINIC_FRAGMENT}
`;

export default STUDY_INFO_CLINIC_QUERY;
